export const credentialingFeatureKey = 'credentialing';
